export const credentialingFeatureKey = 'credentialing';
